import React from "react";
import "../styles/Resume.css"

function Resume() {
    return (
        <div id="resume">
            <div className="card mb-3 p-2 d-flex">
                <div className="row no-gutters border-bottom">
                    <div className="col-md-4">
                        <div className="card-body">
                            <h4 className="card-title" id="education">Education</h4>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card-body text-left" id="school">
                            <h5 className="card-title">Vanderbilt University</h5>
                            <h6 className="card-title">Full Stack Web Development &bull; August 2020</h6>
                            <p className="card-text text-muted">A rigorous 12-week curriculum that covers a full-stack: HTML5, CSS3, JavaScript, jQuery, Bootstrap, Express.js, React.js, Node.js, Database Theory, MongoDB, MySQL, Command Line, Git, and more.</p>
                        </div>
                        <div className="card-body text-left" id="school">
                            <h5 className="card-title">Southern New Hampshire University</h5>
                            <h6 className="card-title">New Media &amp; Marketing &bull; April 2019</h6>
                            <p className="card-text text-muted">Graduate communication program focusing on social media practices, reputation management, personal and corporate brand building, writing for digital platforms, ethics and marketing campaign design.</p>
                        </div>
                        <div className="card-body text-left" id="school">
                            <h5 className="card-title">University of Tennessee</h5>
                            <h6 className="card-title">Journalism &amp; Electronic Media &bull; May 2010</h6>
                            <p className="card-text text-muted">Undergraduate program with a focuse on broadcast journalism, radio-TV-web reporting, producing, and anchoring multimedia for all electronic media.</p>
                        </div>
                    </div>
                </div>
                {/* ================================================================================ */}
                <div className="row no-gutters border-bottom">
                    <div className="col-md-4">
                        <div className="card-body">
                            <h4 className="card-title" id="education">Work</h4>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card-body text-left" id="school">
                            <h5 className="card-title">Scripps Networks Interactive</h5>
                            <h6 className="card-title">Network Operations Technician &bull; December 2015 - February 2019</h6>
                            <p className="card-text text-muted">Responsible for assisting the Application Management team in troubleshooting issues of routers, patch bays, waveform monitors and encoded. Resolving any issues related to the servers, networks and telecommunications by consistently troubleshooting and monitoring for networks such as HGTV, Food Network, Travel Channel, DIY, Cooking Channel and GAC.</p>
                        </div>
                        <div className="card-body text-left" id="school">
                            <h5 className="card-title">Jewelry Television</h5>
                            <h6 className="card-title">Technical Director, Production Member &bull; September 2010 - December 2015</h6>
                            <p className="card-text text-muted">Executed live show content, preplanned meetings with producers and hosts to attain best revenue performance. Supervised production department, addressing performance and attendance concerns and mentoring new and experienced employees to demonstrate best practices with confidence.</p>
                        </div>
                    </div>
                </div>
                {/* ================================================================================ */}
                <div className="row no-gutters mt-2">
                    <div className="col-md-4">
                        <div className="card-body">
                            <h4 className="card-title" id="education">Skills</h4>
                        </div>
                    </div>
                    <div className="row">
                    <div className="col-3 m-2">
                        <div>
                            <i className="fab fa-html5 fa-5x" alt="HTML5"></i>
                        </div>
                    </div>
                    <div className="col-3 m-2">
                        <div>
                            <i className="fab fa-css3-alt fa-5x"></i>
                        </div>
                    </div>
                    <div className="col-3 m-2">
                        <div>
                            <i className="fab fa-js-square fa-5x"></i>
                        </div>
                    </div>
                    <div className="col-3 m-2">
                        <div>
                            <i className="fab fa-node-js fa-5x"></i>
                        </div>
                    </div>
                    <div className="col-3 m-2">
                        <div>
                            <i className="fab fa-react fa-5x"></i>
                        </div>
                    </div>
                    <div className="col-3 m-2">
                        <div>
                            <i className="fab fa-git-square fa-5x"></i>
                        </div>
                    </div>
                    </div>
                    <br />
                </div>
            </div>
        </div>
    )
};

export default Resume;